function titlePopup(elem, land) {
    var title = document.createElement('div');
    title.id = 'title';
    title.classList.add('title');
    title.innerHTML = land;
    elem.appendChild(title);
}